
@import '../../global/styles.css';

.btn {
    background: var(--primary-color);
    padding: 12px 16px;
    border-radius: 12px;
    border: 2px solid var(--primary-color);
    color: var(--white-color);
    font-size: 14px;
    cursor: pointer;
    margin: 0 2px;
}

.btn:hover {
    background: #0098DB;
}

/* when pressed */

.btn:active {
    background: #0098DB;
    border: 2px solid var(--white-color);
    box-shadow: 0px 0px 4px #99ADED;
}

.btn.sm {
    padding: 8px 12px;
}

.btn.lg {
    padding: 16px 32px;
}

.btn.extended{
    width: 100%;
}

.btn.xlg{
    width: 45%;
}
/* when disabled */

.btn.disabled {
    background: var(--disabled-color)!important;
    cursor: not-allowed!important;
    pointer-events: none;
    border: 2px solid var(--disabled-color);
}

.btn.primary {
    background: var(--primary-color);
    border: 2px solid var(--primary-color);
}

.btn.white {
  background:var(--white-color);
  border: 2px solid #5d5d5d;
  color: #5d5d5d;
}
.btn.secondary {
    color: var(--black-color);
    background: var(--secondary-color);
    border: 2px solid var(--secondary-color);
}

.btn.success {
    background: var(--success-color);
    border: 2px solid var(--success-color);
}

.btn.danger {
    background: var(--danger-color);
    border: 2px solid var(--danger-color);
}

.btn.warning {
    background: var(--warning-color);
    border: 2px solid var(--warning-color);
}

.btn.info {
    background: var(--info-color);
    border: 2px solid var(--info-color);
}


.btn.primary:hover {
    background: var(--primary-hover-color);
    border: 2px solid var(--primary-hover-color);
}

.btn.secondary:hover {
    background: var(--secondary-hover-color);
    border: 2px solid var(--secondary-hover-color);
}

.btn.success:hover {
    background: var(--success-hover-color);
    border: 2px solid var(--success-hover-color);
}

.btn.danger:hover {
    background: var(--danger-hover-color);
    border: 2px solid var(--danger-hover-color);
}

.btn.white:hover {
    border: 2px solid var(--primary-hover-color);
    color: var(--primary-color);
}


.btn.warning:hover {
    background: var(--warning-hover-color);
    border: 2px solid var(--warning-hover-color);
}

.btn.info:hover {
    background: var(--info-hover-color);
    border: 2px solid var(--info-hover-color);
}


.btn.textButton {
    background: none  !important;
    border: none !important;
    padding:2px;
  }
  .btn.disabled.textButton {
    background: var(--disabled-color) !important;
    color: #5d5d5d
  }
  .btn.textButton:hover {
    /* background:var(--disabled-color) !important; */
    padding:2px;
  }
.btn.textButton.primary {
    color: var(--primary-color);
  }
.btn.textButton.secondary {
    color: var(--secondary-color);
  }
.btn.textButton.success {
    color: var(--success-color);
  }
.btn.textButton.danger {
    color: var(--danger-color);
  }
.btn.textButton.warning {
    color: var(--warning-color);
}
.btn.textButton.info {
    color: var(--info-color);
}
.btn.textButton.white {
    color: var(--white-color);
    
}





  
.btn.iconButton {
    /* Styles for icon button */
    background: none;
    border: none ;
    padding: 1px 3px;
    vertical-align: middle;
    border-radius: 50%;
}
.btn.iconButton:hover {
    /* background:var(--disabled-color-opacity) !important; */
    border: none;
    background: none !important
}
/* .btn.iconButton.primary:hover {
    background: var(--primary-hover);
  }
.btn.iconButton.secondary:hover {
    background: var(--secondary-hover);
  }
.btn.iconButton.success:hover {
    background: var(--success-color-opacity);
  }
.btn.iconButton.danger:hover{
    background: var(--danger-color-opacity);
  }
.btn.iconButton.warning:hover {
    background: var(--warning-color-opacity);
}
.btn.iconButton.info:hover {
    background: var(--info-color-opacity);
}
.btn.iconButton.white:hover {
    /* border:1px black solid; 
}

 */




  
  .btn.iconButton .icon {
    /* Styles for the icon inside icon button */
    display: inline-block;
  }